export default __webpack_public_path__ + "static/medium-image-yangol-1-d75e50558d4b53cd3bc64497f929f9af.png";